var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3581 20.8515C18.2154 20.8515 18.083 20.8006 17.9607 20.6987L12 15.9301L6.0393 20.6987C5.83552 20.8617 5.61135 20.8923 5.36681 20.7904C5.12227 20.6681 5 20.4745 5 20.2096V3.64193C5 3.45852 5.06114 3.30567 5.18341 3.1834C5.30568 3.06113 5.45851 3 5.64192 3H18.3581C18.5415 3 18.6943 3.06113 18.8166 3.1834C18.9389 3.30567 19 3.45852 19 3.64193V20.2096C19 20.393 18.9389 20.5458 18.8166 20.6681C18.6943 20.7904 18.5415 20.8515 18.3581 20.8515ZM12 14.4629C12.1426 14.4629 12.2751 14.5138 12.3974 14.6157L17.7467 18.8646V4.28385H6.28384V18.8646L11.6026 14.6157C11.7249 14.5138 11.8574 14.4629 12 14.4629Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/Status.7d6b7d3766c08f8ac435f48780457f0b.svg";
export { ForwardRef as ReactComponent };